import {useCallback, useEffect, useState} from 'react';
import "./AppTabsComponent.scss";
import CommonService from "@/services/common.service.ts";

import AppCodeAndPreviewComponent
    from "@/screens/app/project/universal-app-builder-layout/universal-app-builder/app-tabs/app-code-and-preview/AppCodeAndPreviewComponent.tsx";
import AppTabsHeaderBarComponent from "./app-tabs-header-bar/AppTabsHeaderBarComponent.tsx";
import {AppType} from "@/models/project.model.ts";
import {useDispatch} from "react-redux";

export default function AppTabsComponent(props: Readonly<{
    projectId: any;
    appType: AppType;
    onSupobaseToolOpen: () => void;
    currentAppConfiguration: string[];
    isChatCollapsed: boolean;
    onExpandChat: () => void;
}>) {
    const {
        appType,
        projectId,
        onSupobaseToolOpen,
        currentAppConfiguration,
        isChatCollapsed,
        onExpandChat
    } = props;

    const [activeTab, setActiveTab] = useState<string>("preview");
    const dispatch = useDispatch();

    const handleTabChange = useCallback((newValue: string) => {
        setActiveTab(newValue)
        if (newValue === "preview") {
            CommonService.handleMixpanelTrack("switched_to_code_tab")
        } else {
            CommonService.handleMixpanelTrack("switched_to_preview_tab")
        }
    },[])

    useEffect(() => {
        const codeAndPreviewSwitch = CommonService._communications.switchCodeAndPreviewSubject.subscribe((value: boolean) => {
            if (value){
                setActiveTab("code");
            }
            else {
                setActiveTab("preview");
            }
        });
        const endSub = CommonService._communications.endCodeStreamerSubject.subscribe((value: boolean) => {
            if (value) setActiveTab("preview");
        });

        return () => {
            codeAndPreviewSwitch.unsubscribe();
            endSub.unsubscribe();
        };
    }, [dispatch]);

    return (
        <div className="app-tabs-wrapper">
            <AppTabsHeaderBarComponent 
                onSupobaseToolOpen={onSupobaseToolOpen}
                currentAppConfiguration={currentAppConfiguration}
                projectId={projectId}
                appType={appType}
                activeTab={activeTab}
                onTabChange={handleTabChange}
                isChatCollapsed={isChatCollapsed}
                onExpandChat={onExpandChat}
            />
            <div className="tabs-wrapper">
                <AppCodeAndPreviewComponent appType={appType} activeTab={activeTab} isFullScreen={false} />
            </div>
        </div>
    );
}